var _path, _g, _path2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoLogoPaypaySp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_28_9108",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 31,
    height: 31
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H30.0309V30.0075H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_28_9108)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.591 -0.000305176C28.0329 -0.000305176 30.031 1.99658 30.031 4.43665V25.5706C30.031 28.0107 28.0329 30.0072 25.591 30.0072L4.44042 30.0076C1.99845 30.0076 0 28.0107 0 25.5706V9.39051L0.0118728 4.19895C0.137809 1.86862 2.07859 -0.000305176 4.44085 -0.000305176H25.591Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_28_9108",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 31,
    height: 31
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H30.0309V30.0075H0V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_28_9108)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.591 -0.000305176H4.44085C2.07858 -0.000305176 0.137807 1.86862 0.0118706 4.19895C17.7193 3.69899 26.3326 9.8553 24.9804 15.9921C23.7625 21.518 18.1446 23.6365 9.01526 24.3322L7.64989 30.0072H25.591C28.0329 30.0072 30.031 28.0107 30.031 25.5706V4.43665C30.031 1.99658 28.0329 -0.000305176 25.591 -0.000305176ZM23.9105 16.0192C24.6144 13.1529 19.99 10.5014 12.5835 9.50025L9.89471 20.6769C16.1021 20.9706 23.1532 19.1033 23.9105 16.0192ZM5.84862 30.0076H4.44042C1.99845 30.0076 0 28.0107 0 25.5706V9.39051C3.98502 8.988 7.70163 8.99605 10.9611 9.31297L5.84862 30.0076Z",
    fill: "#FF0033"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLogoPaypaySp);
export default __webpack_public_path__ + "static/media/ico_logo_paypay_sp.bb4b5a57bc41b2756eef4a815e2d8aef.svg";
export { ForwardRef as ReactComponent };